export default {
  updateScreenState ({ commit }, size) {
    if (size < 991) {
      commit('setScreenSize', 'small')
      return
    }
    if (size > 1440) {
      commit('setScreenSize', 'large')
      return
    }
    commit('setScreenSize', 'medium')
  }
}
